import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import { UpgradeApiClientContext } from '../upgrade.context';
import { dynamicLoadUpgradeQueries } from '../utils';
export const getCurrentProductStatusQueryFn = async _ref => {
  let {
    httpClient
  } = _ref;
  const {
    getCurrentProduct
  } = await dynamicLoadUpgradeQueries(httpClient);
  const {
    currentProduct
  } = await getCurrentProduct({});
  const {
    getPurchaseUserOffering
  } = PremiumPurchasePlatformModule.SDK.ApiClient.queries({
    httpClient
  });
  const p3Context = UpgradeApiClientContext.get('p3Context');
  if (!p3Context) {
    throw new Error('P3 context is required to get current product status');
  }
  const getPurchaseUserOfferingResponse = await getPurchaseUserOffering({
    ...p3Context
  });
  const {
    products = []
  } = getPurchaseUserOfferingResponse;
  const currentProductInOffering = products == null ? void 0 : products.some(product => product.productId === (currentProduct == null ? void 0 : currentProduct.productId));
  if (currentProductInOffering) {
    return {
      status: 'currentProductInOffering'
    };
  }
  const currentProductFamilyInOffering = products == null ? void 0 : products.some(product => product.productFamilyId === (currentProduct == null ? void 0 : currentProduct.productFamilyId));
  if (currentProductFamilyInOffering) {
    return {
      status: 'currentProductFamilyInOffering'
    };
  }
  if (currentProduct) {
    return {
      status: 'currentProductIsNotInOffering'
    };
  }
  return {
    status: 'noCurrentProduct'
  };
};
//# sourceMappingURL=getCurrentProductStatus.query.js.map